(() => {
  'use strict';
  const node = document.getElementById('RegionalRoutingConfig');
  if (!node) return;
  const config = JSON.parse(node.textContent), core = window.ThornvellaRegional;
  if (!core) return;
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const requestedPreview = new URL(location.href).searchParams.get('preview_theme_id');
  const previewTheme = requestedPreview && /^\d+$/.test(requestedPreview) ? requestedPreview : window.Shopify?.theme?.role === 'unpublished' ? String(window.Shopify.theme.id) : null;
  const previewUrl = path => {
    const url = new URL(path, location.origin);
    if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
    return url.pathname + url.search;
  };
  const strings = config.strings, cartForm = document.querySelector('[data-regional-cart]');
  const productForm = document.querySelector('#ProductForm');
  const message = cartForm?.querySelector('[data-regional-cart-status]') || document.querySelector('[data-regional-empty-status]') || document.querySelector('[data-regional-product-status]') || document.querySelector('[data-regional-message]');
  const checkout = cartForm?.querySelector('[name="checkout"]');
  const journalKey = 'thornvella-regional-transaction-v2', lockKey = 'thornvella-regional-lock-v2';
  const transfer = window.ThornvellaTransfer;
  let indexPromise, running, ready = false, switching = false, needsChoice = false, lease, transferSource, carried = false;
  const issue = code => Object.assign(new Error(code), { code });
  const journal = {
    get: () => JSON.parse(localStorage.getItem(journalKey) || 'null'),
    set: value => localStorage.setItem(journalKey, JSON.stringify(value)),
    clear: () => localStorage.removeItem(journalKey)
  };
  async function locked(callback) {
    if (navigator.locks) return navigator.locks.request(lockKey, callback);
    const current = JSON.parse(localStorage.getItem(lockKey) || 'null');
    if (current && current.expires > Date.now()) throw issue('changed');
    lease = crypto.randomUUID();
    const renew = () => localStorage.setItem(lockKey, JSON.stringify({ id: lease, expires: Date.now() + 60000 }));
    renew();
    const timer = setInterval(renew, 20000);
    try { return await callback(); }
    finally {
      clearInterval(timer);
      if (JSON.parse(localStorage.getItem(lockKey) || 'null')?.id === lease) localStorage.removeItem(lockKey);
      lease = undefined;
    }
  }
  const request = async (url, body) => {
    const response = await fetch(url, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined });
    if (!response.ok) throw issue('retry');
    return response.json();
  };
  async function context() {
    if (lease && JSON.parse(localStorage.getItem(lockKey) || 'null')?.id !== lease) throw issue('changed');
    const response = await fetch(previewUrl(root + 'cart?view=regional-context'), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' } });
    if (!response.ok) throw issue('retry');
    const current = JSON.parse(await response.text());
    if (current.country !== config.country || current.currency !== config.currency) throw issue('changed');
    return current;
  }
  const api = {
    cart: async () => {
      const cart = await request(root + 'cart.js');
      if (cart.currency !== config.currency) throw issue('changed');
      return cart;
    },
    guard: context,
    add: items => request(root + 'cart/add.js', { items }),
    update: (updates, metadata = {}) => request(root + 'cart/update.js', { updates, ...metadata }),
    change: (id, quantity, properties) => request(root + 'cart/change.js', { id, quantity, properties })
  };
  const index = () => indexPromise ||= fetch(config.index_url, { credentials: 'omit' }).then(response => {
    if (!response.ok) throw issue('retry');
    return response.json();
  }).then(core.expand).catch(error => { indexPromise = undefined; throw error; });
  const productUrl = (handle, variant) => previewUrl(root + 'products/' + encodeURIComponent(handle) + (variant ? '?variant=' + encodeURIComponent(variant) : ''));
  const loadProduct = handle => request(root + 'products/' + encodeURIComponent(handle) + '.js').catch(() => {
    throw Object.assign(issue('unavailable'), { links: [{ handle }] });
  });
  function status(key, links = []) {
    if (!message) return;
    message.replaceChildren();
    const text = document.createElement('p');
    text.textContent = strings[key] || strings.retry;
    message.append(text);
    for (const [i, item] of links.entries()) {
      const link = document.createElement('a');
      link.href = productUrl(item.handle, item.variant);
      link.textContent = strings.view_product + (links.length > 1 ? ' ' + (i + 1) : '');
      message.append(link);
    }
    message.hidden = false;
    message.closest('[data-regional-message-wrap]')?.removeAttribute('hidden');
  }
  function enabled() { if (checkout) checkout.disabled = !ready || switching; }
  function fail(error) {
    ready = false; switching = false;
    document.body.classList.remove('is-country-switching');
    if (transferSource) transfer.suspend();
    enabled();
    status(error.code || 'retry', error.links || []);
    if (message) {
      if (transferSource) {
        const original = document.createElement('a');
        original.href = transferSource;
        original.textContent = strings.original_cart;
        message.append(original);
      }
      const retry = document.createElement('button');
      retry.type = 'button'; retry.textContent = strings.retry_button;
      retry.addEventListener('click', () => { transfer?.resume(); location.reload(); });
      message.append(retry);
    }
  }
  function lockDisplay() {
    ready = false; enabled();
    document.body.classList.add('is-country-switching');
    document.querySelectorAll('[data-add-to-cart], .product-card__quick-add[type="submit"]').forEach(button => { button.disabled = true; });
    cartForm?.setAttribute('aria-busy', 'true');
  }
  function refreshCart() {
    const url = new URL(root + 'cart', location.origin);
    url.searchParams.set('tv_regional_updated', config.country);
    if (carried) url.searchParams.set('tv_regional_carried', config.country);
    location.replace(previewUrl(url.href));
  }
  async function receiveCart(cart, data) {
    const incoming = await transfer?.pending();
    if (!incoming) return { cart, changed: false };
    transferSource = new URL(incoming.r + 'cart', incoming.s).href;
    if (previewTheme) {
      const original = new URL(transferSource);
      original.searchParams.set('preview_theme_id', previewTheme);
      transferSource = original.href;
    }
    if (incoming.c !== config.country) throw issue('transfer');
    const items = transfer.items(incoming);
    if (!core.sameBasket(cart, items)) {
      const resolved = await core.resolve({ items }, data, config.country, loadProduct);
      cart = await core.importBasket(resolved.map(item => item.target), api, journal, incoming.n);
    }
    const attributes = { ...Object.fromEntries(Object.keys(cart.attributes || {}).map(k => [k, ''])), ...incoming.attributes };
    const metadata = { note: incoming.note || '', attributes };
    if (incoming.discounts.length) metadata.discount = incoming.discounts.join(',');
    await context();
    await api.update({}, metadata);
    transfer.clear();
    transferSource = undefined;
    carried = true;
    return { cart: await api.cart(), changed: true };
  }
  async function reconcile() {
    if (running) return running;
    ready = false; enabled(); status('checking');
    cartForm?.setAttribute('aria-busy', 'true');
    running = locked(async () => {
      await context();
      let cart = await api.cart();
      const unfinished = journal.get();
      let changed = Boolean(unfinished);
      if (unfinished) cart = unfinished.type === 'import' ? await core.finishImport(unfinished, api, journal) : await core.finish(unfinished, api, journal);
      const data = await index(), received = await receiveCart(cart, data);
      cart = received.cart;
      changed ||= received.changed;
      const changes = await core.plan(cart, data, config.country, loadProduct);
      if (changes.additions.length) {
        await core.replace(changes, api, journal, crypto.randomUUID());
        changed = true;
      }
      await context();
      return changed;
    });
    try {
      const changed = await running;
      if (changed) { refreshCart(); return true; }
      ready = true; enabled();
      const parameters = new URL(location.href).searchParams;
      status(parameters.get('tv_regional_carried') === config.country ? 'carried' : parameters.get('tv_regional_updated') === config.country ? 'updated' : 'ready');
      return false;
    } catch (error) { fail(error); throw error; }
    finally { running = undefined; cartForm?.removeAttribute('aria-busy'); }
  }
  async function syncQuantities() {
    const cart = await api.cart();
    if (!cartForm) return cart;
    const inputs = [...cartForm.querySelectorAll('[data-line-key]')];
    if (inputs.length !== cart.items.length || inputs.some(input => !cart.items.some(item => item.key === input.dataset.lineKey))) throw issue('changed');
    const updates = {};
    for (const input of inputs) {
      const quantity = Number(input.value);
      if (!Number.isSafeInteger(quantity) || quantity < 0) { input.focus(); throw issue('retry'); }
      if (quantity !== cart.items.find(item => item.key === input.dataset.lineKey).quantity) updates[input.dataset.lineKey] = quantity;
    }
    if (!Object.keys(updates).length) return cart;
    await context();
    await api.update(updates);
    return api.cart();
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.querySelector('[name="country_code"]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (switching) return;
    switching = true; lockDisplay(); status('switching');
    try {
      await locked(async () => {
        await context();
        const country = form.querySelector('[name="country_code"]').value, cart = await syncQuantities();
        let destination = new URL(location.href).pathname;
        if (cart.item_count || journal.get()) destination = root + 'cart';
        else if (config.product) {
          const targets = core.targetsFor(config.product.handle, await index(), country);
          if (targets.length === 1) {
            const url = new URL(productUrl(targets[0]), location.origin);
            const selectedId = productForm?.querySelector('[name="id"]')?.value;
            const selected = config.product.variants.find(variant => String(variant.id) === selectedId);
            if (selected) url.searchParams.set('tv_options', JSON.stringify(config.product.options.map((name, i) => ({ name, value: selected.options[i] }))));
            const quantity = Number(productForm?.querySelector('[name="quantity"]')?.value);
            if (Number.isSafeInteger(quantity) && quantity > 0) url.searchParams.set('tv_quantity', String(quantity));
            destination = url.pathname + url.search;
          } else destination = root + 'collections/all';
        }
        let returnTo = form.querySelector('[name="return_to"]');
        if (!returnTo) { returnTo = document.createElement('input'); returnTo.type = 'hidden'; returnTo.name = 'return_to'; form.append(returnTo); }
        const returnUrl = new URL(previewUrl(destination), location.origin);
        if (cart.item_count) returnUrl.searchParams.set('tv_cart', await transfer.pack(cart, country, location.origin, root));
        returnTo.value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
        HTMLFormElement.prototype.submit.call(form);
      });
    } catch (error) {
      switching = false;
      document.querySelectorAll('[name="country_code"]').forEach(select => { select.value = config.country; });
      document.body.classList.remove('is-country-switching');
      cartForm?.removeAttribute('aria-busy');
      fail(error);
    }
  }, true);
  if (cartForm) {
    cartForm.addEventListener('submit', async event => {
      event.preventDefault(); event.stopImmediatePropagation();
      if (running || switching) return;
      ready = false; enabled();
      try {
        await locked(async () => { await context(); await syncQuantities(); });
        if (event.submitter?.name !== 'checkout') { location.reload(); return; }
        const changed = await reconcile();
        if (!changed && ready) { await context(); location.assign(root + 'checkout'); }
      } catch (error) { fail(error); }
    });
    reconcile().catch(() => {});
  }
  else transfer?.pending().then(incoming => {
    if (!incoming) return;
    switching = true; lockDisplay();
    reconcile().catch(() => {});
  }).catch(fail);
  if (productForm && config.product) {
    const button = productForm.querySelector('[data-add-to-cart]');
    if (button) button.disabled = true;
    const params = new URL(location.href).searchParams;
    const quantity = Number(params.get('tv_quantity'));
    if (Number.isSafeInteger(quantity) && quantity > 0) productForm.querySelector('[name="quantity"]').value = String(quantity);
    needsChoice = params.has('tv_choose');
    if (params.has('tv_options')) {
      try {
        const variant = core.matchVariant({ options_with_values: JSON.parse(params.get('tv_options')) }, config.product);
        if (variant?.available) {
          const select = productForm.querySelector('[name="id"]');
          select.value = String(variant.id);
          select.dispatchEvent(new Event('change', { bubbles: true }));
          const names = config.product.options.map(name => name.toLowerCase().replace('colour', 'color'));
          const size = productForm.querySelector('[data-variant-size]'), color = productForm.querySelector('[data-variant-colour]');
          if (color) color.value = variant.options[names.indexOf('color')];
          if (size) size.value = variant.options[names.indexOf('size')];
        } else needsChoice = true;
      } catch (_) { needsChoice = true; }
    }
    index().then(async data => {
      await context();
      const targets = core.targetsFor(config.product.handle, data, config.country);
      if (targets.length !== 1) throw Object.assign(issue('unavailable'), { links: targets.map(handle => ({ handle })) });
      if (targets[0] !== config.product.handle) {
        const url = new URL(productUrl(targets[0]), location.origin);
        const selected = config.product.variants.find(v => String(v.id) === productForm.querySelector('[name="id"]').value);
        if (selected) url.searchParams.set('tv_options', JSON.stringify(config.product.options.map((name, i) => ({ name, value: selected.options[i] }))));
        url.searchParams.set('tv_quantity', productForm.querySelector('[name="quantity"]').value);
        location.replace(url.href);
        return;
      }
      ready = true;
      if (needsChoice) status('choose_option');
      const selected = config.product.variants.find(v => String(v.id) === productForm.querySelector('[name="id"]').value);
      if (button) button.disabled = needsChoice || !selected?.available;
    }).catch(fail);
    productForm.addEventListener('change', event => {
      if (!event.target.matches('[data-variant-select], [data-variant-colour], [data-variant-size]')) return;
      needsChoice = false;
      const selected = config.product.variants.find(v => String(v.id) === productForm.querySelector('[name="id"]').value);
      if (button) button.disabled = !ready || !selected?.available;
      if (ready) status('ready');
    });
    let productSubmitting = false;
    productForm.addEventListener('submit', async event => {
      event.preventDefault(); event.stopImmediatePropagation();
      if (!ready || needsChoice || switching || productSubmitting) return;
      productSubmitting = true;
      if (button) button.disabled = true;
      try {
        await context();
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(productForm)
        });
        const added = await response.json();
        if (!response.ok || added.status) throw issue('retry');
        const cart = await api.cart();
        document.querySelectorAll('a.icon-button[href]').forEach(link => {
          if (new URL(link.href, location.origin).pathname !== root + 'cart') return;
          link.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
          let count = link.querySelector('.icon-button__count');
          if (!count) { count = document.createElement('span'); count.className = 'icon-button__count'; link.append(count); }
          count.textContent = String(cart.item_count);
        });
        if (message) {
          const confirmation = document.createElement('p'), link = document.createElement('a');
          confirmation.textContent = 'Added to your cart.';
          link.href = previewUrl(root + 'cart');
          link.textContent = 'View cart';
          message.replaceChildren(confirmation, link);
          message.setAttribute('role', 'status');
          message.hidden = false;
          message.closest('[data-regional-message-wrap]')?.removeAttribute('hidden');
        }
      } catch (error) {
        fail(error);
      } finally {
        productSubmitting = false;
        const selected = config.product.variants.find(v => String(v.id) === productForm.querySelector('[name="id"]').value);
        if (button) button.disabled = !ready || needsChoice || switching || !selected?.available;
      }
    });
  }
  if (config.page === '404') {
    index().then(data => {
      const handle = decodeURIComponent(location.pathname.split('/products/')[1]?.split('/')[0] || '');
      if (!data.products[handle]) return;
      const targets = core.targetsFor(handle, data, config.country);
      if (targets.length === 1 && targets[0] !== handle) {
        const url = new URL(productUrl(targets[0]), location.origin);
        if (new URL(location.href).searchParams.has('variant')) url.searchParams.set('tv_choose', '1');
        location.replace(url.href);
      } else if (targets.length) status('edition', targets.map(handle => ({ handle })));
    }).catch(fail);
  }
  window.addEventListener('pageshow', event => { if (event.persisted) location.reload(); });
})();

